var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-slide-ppt-wrp",class:{'hidden': _vm.isWhiteLabel}},[_c('div',{staticClass:"toolbar-container bg-white-100 flex rounded-lg py-1.5"},[(_vm.canUseAIImproveDirectly)?_c('div',{staticClass:"improve-container"},[_c('ImproveWritingDropDown',{staticClass:"h-full flex items-center"})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }